/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ stickySection)
});

;// external "@babel/runtime/helpers/jsx"
const jsx_namespaceObject = require("@babel/runtime/helpers/jsx");
var jsx_default = /*#__PURE__*/__webpack_require__.n(jsx_namespaceObject);
;// external "@babel/runtime/helpers/slicedToArray"
const slicedToArray_namespaceObject = require("@babel/runtime/helpers/slicedToArray");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_namespaceObject);
;// external "core-js/modules/es.array.concat.js"
const es_array_concat_js_namespaceObject = require("core-js/modules/es.array.concat.js");
;// external "core-js/modules/es.array.map.js"
const es_array_map_js_namespaceObject = require("core-js/modules/es.array.map.js");
;// external "core-js/modules/es.array.some.js"
const es_array_some_js_namespaceObject = require("core-js/modules/es.array.some.js");
;// external "core-js/modules/es.object.to-string.js"
const es_object_to_string_js_namespaceObject = require("core-js/modules/es.object.to-string.js");
;// external "core-js/modules/es.string.link.js"
const es_string_link_js_namespaceObject = require("core-js/modules/es.string.link.js");
;// external "core-js/modules/esnext.iterator.constructor.js"
const esnext_iterator_constructor_js_namespaceObject = require("core-js/modules/esnext.iterator.constructor.js");
;// external "core-js/modules/esnext.iterator.map.js"
const esnext_iterator_map_js_namespaceObject = require("core-js/modules/esnext.iterator.map.js");
;// external "core-js/modules/esnext.iterator.some.js"
const esnext_iterator_some_js_namespaceObject = require("core-js/modules/esnext.iterator.some.js");
;// external "react"
const external_react_namespaceObject = require("react");
;// external "prop-types"
const external_prop_types_namespaceObject = require("prop-types");
;// external "classnames"
const external_classnames_namespaceObject = require("classnames");
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_namespaceObject);
;// external "frontend-image"
const external_frontend_image_namespaceObject = require("frontend-image");
var external_frontend_image_default = /*#__PURE__*/__webpack_require__.n(external_frontend_image_namespaceObject);
;// external "@babel/runtime/helpers/objectSpread2"
const objectSpread2_namespaceObject = require("@babel/runtime/helpers/objectSpread2");
var objectSpread2_default = /*#__PURE__*/__webpack_require__.n(objectSpread2_namespaceObject);
;// external "@babel/runtime/helpers/objectWithoutProperties"
const objectWithoutProperties_namespaceObject = require("@babel/runtime/helpers/objectWithoutProperties");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_namespaceObject);
;// external "@babel/runtime/helpers/typeof"
const typeof_namespaceObject = require("@babel/runtime/helpers/typeof");
var typeof_default = /*#__PURE__*/__webpack_require__.n(typeof_namespaceObject);
;// external "core-js/modules/es.array.for-each.js"
const es_array_for_each_js_namespaceObject = require("core-js/modules/es.array.for-each.js");
;// external "core-js/modules/es.array.includes.js"
const es_array_includes_js_namespaceObject = require("core-js/modules/es.array.includes.js");
;// external "core-js/modules/es.array.iterator.js"
const es_array_iterator_js_namespaceObject = require("core-js/modules/es.array.iterator.js");
;// external "core-js/modules/es.date.to-iso-string.js"
const es_date_to_iso_string_js_namespaceObject = require("core-js/modules/es.date.to-iso-string.js");
;// external "core-js/modules/es.date.to-string.js"
const es_date_to_string_js_namespaceObject = require("core-js/modules/es.date.to-string.js");
;// external "core-js/modules/es.function.name.js"
const es_function_name_js_namespaceObject = require("core-js/modules/es.function.name.js");
;// external "core-js/modules/es.object.entries.js"
const es_object_entries_js_namespaceObject = require("core-js/modules/es.object.entries.js");
;// external "core-js/modules/es.object.keys.js"
const es_object_keys_js_namespaceObject = require("core-js/modules/es.object.keys.js");
;// external "core-js/modules/es.object.values.js"
const es_object_values_js_namespaceObject = require("core-js/modules/es.object.values.js");
;// external "core-js/modules/es.regexp.exec.js"
const es_regexp_exec_js_namespaceObject = require("core-js/modules/es.regexp.exec.js");
;// external "core-js/modules/es.string.iterator.js"
const es_string_iterator_js_namespaceObject = require("core-js/modules/es.string.iterator.js");
;// external "core-js/modules/es.string.replace.js"
const es_string_replace_js_namespaceObject = require("core-js/modules/es.string.replace.js");
;// external "core-js/modules/es.string.replace-all.js"
const es_string_replace_all_js_namespaceObject = require("core-js/modules/es.string.replace-all.js");
;// external "core-js/modules/es.string.starts-with.js"
const es_string_starts_with_js_namespaceObject = require("core-js/modules/es.string.starts-with.js");
;// external "core-js/modules/esnext.iterator.for-each.js"
const esnext_iterator_for_each_js_namespaceObject = require("core-js/modules/esnext.iterator.for-each.js");
;// external "core-js/modules/web.dom-collections.for-each.js"
const web_dom_collections_for_each_js_namespaceObject = require("core-js/modules/web.dom-collections.for-each.js");
;// external "core-js/modules/web.dom-collections.iterator.js"
const web_dom_collections_iterator_js_namespaceObject = require("core-js/modules/web.dom-collections.iterator.js");
;// external "core-js/modules/web.url.js"
const web_url_js_namespaceObject = require("core-js/modules/web.url.js");
;// external "core-js/modules/web.url.can-parse.js"
const web_url_can_parse_js_namespaceObject = require("core-js/modules/web.url.can-parse.js");
;// external "core-js/modules/web.url.to-json.js"
const web_url_to_json_js_namespaceObject = require("core-js/modules/web.url.to-json.js");
;// external "core-js/modules/web.url-search-params.js"
const web_url_search_params_js_namespaceObject = require("core-js/modules/web.url-search-params.js");
;// external "core-js/modules/web.url-search-params.delete.js"
const web_url_search_params_delete_js_namespaceObject = require("core-js/modules/web.url-search-params.delete.js");
;// external "core-js/modules/web.url-search-params.has.js"
const web_url_search_params_has_js_namespaceObject = require("core-js/modules/web.url-search-params.has.js");
;// external "core-js/modules/web.url-search-params.size.js"
const web_url_search_params_size_js_namespaceObject = require("core-js/modules/web.url-search-params.size.js");
;// external "core-js/modules/es.array.join.js"
const es_array_join_js_namespaceObject = require("core-js/modules/es.array.join.js");
;// ./utils/src/stringifySrcset.js





var stringifySrcset = function stringifySrcset(imagePaths) {
  var resolutions = imagePaths ? Object.keys(imagePaths) : [];
  return resolutions.map(function (resolution) {
    return "".concat(imagePaths[resolution], " ").concat(resolution, "w");
  }).join(',');
};
;// ./utils/src/rebranding-images.js




var _excluded = ["imagePath", "imagePaths", "src"];





























var REBRAND_ASSETS_STORAGE = 'https://http2.mlstatic.com/storage/pog-cm-admin/calm-assets/';
var REBRAND_ALLOWED_DOMAINS = ['https://http2.mlstatic.com/frontend-assets/growth-sellers-landings/', 'https://http2.mlstatic.com/resources/frontend/gsl-assets/', 'https://http2.mlstatic.com/storage/mgrowth-cc-blue-hero/', REBRAND_ASSETS_STORAGE];
var REBRAND_ALLOWED_EXTENSIONS = ['png', 'jpeg', 'jpg', 'webp'];
var REBRAND_SUFFIX = '--rebrand-mp';
var REBRAND_IMAGE_EXTENSION = 'webp';
var isValidRebrandDomain = function isValidRebrandDomain(url) {
  return REBRAND_ALLOWED_DOMAINS.some(function (domain) {
    return url === null || url === void 0 ? void 0 : url.startsWith(domain);
  });
};
var clearNameFile = function clearNameFile(name) {
  return {
    cleanName: name === null || name === void 0 ? void 0 : name.split('.').shift()
  };
};
var getNameFromUrl = function getNameFromUrl(url) {
  if (!URL.canParse(url)) {
    return null;
  }
  var urlObject = new URL(url);
  return {
    path: urlObject.pathname,
    name: clearNameFile(urlObject.pathname.split('/').pop()).cleanName
  };
};
var rewriteURL = function rewriteURL(url) {
  var _getNameFromUrl;
  if (!(url !== null && url !== void 0 && url.length) || !URL.canParse(url)) {
    return '';
  }
  var extension = url.split('.').pop();
  if (!REBRAND_ALLOWED_EXTENSIONS.includes(extension) || !isValidRebrandDomain(url)) {
    return url;
  }
  var dateParam = "".concat(new Date().toISOString().split('T')[0].replaceAll('-', ''));
  var filename = (_getNameFromUrl = getNameFromUrl(url)) === null || _getNameFromUrl === void 0 ? void 0 : _getNameFromUrl.name;
  var rebrandFilename = "".concat(filename).concat(REBRAND_SUFFIX, ".").concat(REBRAND_IMAGE_EXTENSION, "?d=").concat(dateParam);
  return "".concat(REBRAND_ASSETS_STORAGE).concat(rebrandFilename);
};
var rewriteImagePaths = function rewriteImagePaths(imagePaths) {
  if (!imagePaths || typeof_default()(imagePaths) !== 'object' || Object.keys(imagePaths).length < 1) {
    return {};
  }
  var clone = {};
  Object.entries(imagePaths).forEach(function (_ref) {
    var _ref2 = slicedToArray_default()(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    clone["".concat(key)] = rewriteURL(value);
  });
  return clone;
};
var getImageProperties = function getImageProperties(image) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!image || typeof_default()(image) !== 'object' || Object.keys(image) < 1) {
    return null;
  }
  var _options$setDefaultSr = options.setDefaultSrc,
    setDefaultSrc = _options$setDefaultSr === void 0 ? false : _options$setDefaultSr,
    _options$setSrcSetStr = options.setSrcSetString,
    setSrcSetString = _options$setSrcSetStr === void 0 ? false : _options$setSrcSetStr,
    _options$setImagePath = options.setImagePathsObject,
    setImagePathsObject = _options$setImagePath === void 0 ? false : _options$setImagePath,
    _options$rewriteURLs = options.rewriteURLs,
    rewriteURLs = _options$rewriteURLs === void 0 ? false : _options$rewriteURLs;
  var imagePath = image.imagePath,
    imagePaths = image.imagePaths,
    initialSrc = image.src,
    otherProps = objectWithoutProperties_default()(image, _excluded);
  var clone = objectSpread2_default()({}, otherProps);
  var paths = imagePaths !== null && imagePaths !== void 0 ? imagePaths : imagePath;
  var src = initialSrc;
  if (rewriteURLs) {
    paths = objectSpread2_default()({}, rewriteImagePaths(paths));
    if (!src && paths) {
      var imagePathsValues = Object.values(paths);
      src = imagePathsValues.length > 0 ? imagePathsValues[0] : '';
    }
    src = rewriteURL(src);
  }
  if (setDefaultSrc) {
    var defaultPath = null;
    try {
      var _Object$values;
      // defaults to second element (768px resource)
      defaultPath = ((_Object$values = Object.values(paths)) === null || _Object$values === void 0 ? void 0 : _Object$values.length) > 1 ? Object.values(paths)[1] : '';
    } catch (err) {
      defaultPath = '';
    }
    clone.src = src !== null && src !== void 0 ? src : defaultPath;
  } else {
    clone.src = src;
  }
  if (setSrcSetString) {
    clone.srcset = stringifySrcset(paths);
  }
  if (setImagePathsObject) {
    clone.imagePaths = objectSpread2_default()({}, paths);
  }
  return clone;
};
;// external "core-js/modules/es.number.constructor.js"
const es_number_constructor_js_namespaceObject = require("core-js/modules/es.number.constructor.js");
;// external "core-js/modules/es.number.is-nan.js"
const es_number_is_nan_js_namespaceObject = require("core-js/modules/es.number.is-nan.js");
;// external "@pog-ui-landings-library/framework"
const framework_namespaceObject = require("@pog-ui-landings-library/framework");
;// ./components/hooks/useOnScreen.js


var useOnScreen = function useOnScreen(ref) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var _useState = (0,external_react_namespaceObject.useState)(false),
    _useState2 = slicedToArray_default()(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var observer = (0,external_react_namespaceObject.useMemo)(function () {
    if (typeof IntersectionObserver !== 'function') {
      setIsVisible(false);
      return null;
    }
    return new IntersectionObserver(function (_ref) {
      var _ref2 = slicedToArray_default()(_ref, 1),
        entry = _ref2[0];
      setIsVisible(entry.isIntersecting);
    }, {
      threshold: threshold
    });
  }, [ref]);
  (0,external_react_namespaceObject.useEffect)(function () {
    if (observer) {
      if (ref !== null && ref !== void 0 && ref.current) {
        observer.observe(ref.current);
      }
    }
    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);
  return {
    isVisible: isVisible,
    observer: observer
  };
};
;// ./components/hooks/useTrackShow.js





var useTrackShow = function useTrackShow(refModule, tracking, sectionMetadata) {
  var requireDispatchCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var _ref = tracking || {},
    onShow = _ref.onShow;
  var refElement = onShow !== null && onShow !== void 0 && onShow.enabled ? refModule : null;
  var customThreshold = Number(onShow === null || onShow === void 0 ? void 0 : onShow.threshold);
  var threshold = 0.9;
  if (!Number.isNaN(customThreshold) && customThreshold >= 0.0 && customThreshold <= 1.0) {
    threshold = customThreshold;
  }
  var trackingHandler = (0,framework_namespaceObject.useTracking)();
  var trackShow = (0,framework_namespaceObject.getShowTrackingFn)(trackingHandler);
  var _useOnScreen = useOnScreen(refElement, threshold),
    isVisible = _useOnScreen.isVisible,
    observer = _useOnScreen.observer;
  (0,external_react_namespaceObject.useEffect)(function () {
    if (isVisible) {
      trackShow(sectionMetadata);
      if (observer) {
        observer.disconnect();
      }
    }
  }, [isVisible]);
  if (requireDispatchCall) {
    var sendTrackShow = function sendTrackShow(data) {
      trackShow(data);
    };
    return {
      isVisible: isVisible,
      sendTrackShow: sendTrackShow
    };
  }
  return {
    isVisible: isVisible
  };
};
/* harmony default export */ const hooks_useTrackShow = (useTrackShow);
;// ./components/sections/stickySection/src/constants/stickyProps.js
var COOKIE_CLASSNAME = '.cookie-consent-banner-opt-out';
var FIXED_ACTIONS_CLASSNAME = '.pog-ui-fixed-actions-section';
var STICKY_POSITION = {
  MOBILE: 54,
  DESKTOP: 96
};
;// external "react/jsx-runtime"
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
;// ./components/sections/stickySection/src/StickySection.js










/**
 * Component dependencies
 */








var namespace = 'pog-ui-sticky-section';

/**
 * StickySection
 */
var StickySection = function StickySection(_ref) {
  var id = _ref.id,
    className = _ref.className,
    isMobile = _ref.isMobile,
    isWebView = _ref.isWebView,
    images = _ref.images,
    tracking = _ref.tracking,
    sectionMetadata = _ref.sectionMetadata;
  var DEFAULT_POSITION = isMobile ? STICKY_POSITION.MOBILE : STICKY_POSITION.DESKTOP;
  var _useState = (0,external_react_namespaceObject.useState)(DEFAULT_POSITION),
    _useState2 = slicedToArray_default()(_useState, 2),
    stickyPosition = _useState2[0],
    setStickyPosition = _useState2[1];
  var componentRef = (0,external_react_namespaceObject.useRef)(null);
  hooks_useTrackShow(componentRef, tracking, sectionMetadata);
  var hasValidImage = images === null || images === void 0 ? void 0 : images.some(function (image) {
    var _image$image;
    return (_image$image = image.image) === null || _image$image === void 0 ? void 0 : _image$image.src;
  });
  (0,external_react_namespaceObject.useEffect)(function () {
    var config = {
      attributes: false,
      childList: true,
      characterData: false,
      subtree: true
    };
    if (!componentRef.current) {
      return;
    }
    var cookieBanner = document.querySelector(COOKIE_CLASSNAME);
    var fixedActions = document.querySelector(FIXED_ACTIONS_CLASSNAME);
    if (!cookieBanner && !fixedActions) {
      return;
    }
    var observer;
    var calculatestickyPosition = function calculatestickyPosition() {
      var cookieHeight = cookieBanner ? cookieBanner.offsetHeight : 0;
      var fixedActionsHeight = fixedActions ? fixedActions.offsetHeight : 0;
      var newstickyPosition = DEFAULT_POSITION + cookieHeight + fixedActionsHeight;
      setStickyPosition(newstickyPosition);
      componentRef.current.style.bottom = "".concat(newstickyPosition, "px");
    };
    calculatestickyPosition();
    if (cookieBanner || fixedActions) {
      observer = new MutationObserver(function () {
        calculatestickyPosition();
      });
      var cookieBannerTarget = cookieBanner === null || cookieBanner === void 0 ? void 0 : cookieBanner.parentElement;
      var fixedActionsTarget = fixedActions === null || fixedActions === void 0 ? void 0 : fixedActions.parentElement;
      if (cookieBannerTarget) {
        observer.observe(cookieBannerTarget, config);
      }
      if (fixedActionsTarget) {
        observer.observe(fixedActionsTarget, config);
      }
    }

    // eslint-disable-next-line consistent-return
    return function () {
      var _observer;
      return (_observer = observer) === null || _observer === void 0 ? void 0 : _observer.disconnect();
    };
  }, [isMobile, stickyPosition]);
  if (!hasValidImage) {
    return null;
  }
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    id: id,
    ref: componentRef,
    className: external_classnames_default()(namespace, className, "".concat(namespace, "--").concat(isMobile ? 'mobile' : 'desktop')),
    children: images === null || images === void 0 ? void 0 : images.map(function (_ref2) {
      var imageId = _ref2.id,
        image = _ref2.image,
        link = _ref2.link;
      var imageProps = getImageProperties(image, {
        setDefaultSrc: true,
        setSrcSetString: true,
        rewriteURLs: false
      });
      return /*#__PURE__*/jsx_default()("a", {
        href: isWebView && link !== null && link !== void 0 && link.webviewHref ? link === null || link === void 0 ? void 0 : link.webviewHref : link === null || link === void 0 ? void 0 : link.href,
        className: "".concat(namespace, "__container")
      }, imageId, /*#__PURE__*/jsx_default()((external_frontend_image_default()), {
        className: "".concat(namespace, "__image"),
        alt: image.alt,
        src: imageProps.src
      }));
    })
  });
};

/**
 * PropTypes
 */

StickySection.defaultProps = {
  id: null,
  className: '',
  isMobile: false,
  isWebView: false,
  images: null
};

/**
 * Export component
 */
/* harmony default export */ const src_StickySection = (StickySection);
;// ./packages/stickySection/src/StickySection.js

/* harmony default export */ const stickySection_src_StickySection = (src_StickySection);
;// ./packages/stickySection/index.js
/**
 * Export Component
 */

/* harmony default export */ const stickySection = (stickySection_src_StickySection);
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=index.production.js.map